import { render } from "./CreateShop.vue?vue&type=template&id=35d40d98"
import script from "./CreateShop.vue?vue&type=script&lang=js"
export * from "./CreateShop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__